import * as React from "react";

import { colors } from "@replohq/lattice/styles/colors";
import ReactConfetti from "react-confetti";

import { BILLING_CONFETTI_EVENT } from "./agentBillingToasts";

const AgentBillingConfettiOverlay: React.FC = () => {
  const [isActive, setIsActive] = React.useState(false);

  // eslint-disable-next-line replo/no-use-effect -- Legacy effect - may or may not be necessary
  React.useEffect(() => {
    const handler = () => setIsActive(true);
    window.addEventListener(BILLING_CONFETTI_EVENT, handler);
    return () => window.removeEventListener(BILLING_CONFETTI_EVENT, handler);
  }, []);

  if (!isActive) {
    return null;
  }

  return (
    <ReactConfetti
      style={{ position: "fixed", top: 0, left: 0, zIndex: 9999 }}
      recycle={false}
      numberOfPieces={300}
      colors={[
        colors.brand.yellow,
        colors.brand.lightGreen,
        colors.brand.darkGreen,
        colors.brand.lightPink,
        colors.brand.magenta,
        colors.brand.purple,
        colors.brand.blue,
      ]}
      onConfettiComplete={() => setIsActive(false)}
    />
  );
};

export default AgentBillingConfettiOverlay;
